
import React from 'react';
import { TFunction, withTranslation } from 'react-i18next';
import Form from '../containers/formNew';
import Button from '../controls/buttons/buttonNew';
import SubmitButton from '../controls/buttons/submitButtonNew';
import "./custom-form.scss";

interface IProps {
  header?: React.ReactElement;
  children: React.ReactNode;                 
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  clear?: () => void;
  model: [any, (m: any) => void];
  emptyClearStates?: Record<string, any>;
  t: TFunction;
}
const CustomForm = ({
  header,
  children,
  onSubmit,
  clear,
  model,
  t,
  emptyClearStates
}: IProps) => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit?.(event);
  };

  return (
    <div className="div-form-filter">
      <Form onSubmit={handleSubmit} model={model} emptyClearStates={emptyClearStates}>
        <>
        { header && 
          <div className="filters-title">
            {header}
          </div>
        }
          <div className="row w-100">
            {children}
          </div>
            {   (clear || onSubmit) &&
                <div className="row mt-4 justify-content-end align-items-center">
                    {clear && 
                        <div className="col-auto clear-filter">
                            <Button
                                className="mt-0"
                                label={t('clear')}
                                disabled={emptyClearStates === model[0]}
                                color="white"
                                onClick={clear}
                            />
                        </div>
                    }
                    { onSubmit &&
                        <div className="col-auto">
                            <SubmitButton label="query" className="mt-0 applyFilter" />
                        </div>
                    }
                </div>
            }
        </>
      </Form>
    </div>
  );
};

export default withTranslation()(CustomForm);